import { recordSentry } from "utils/recordSentry";
import { deleteImageBinary } from "../db/queries/imageBinaryQueries";
import { handleToolboxResponse } from "./s3/handleToolboxResponse";
import deleteImageRoute from "./toolboxQueries/deleteImageRoute";

/**
 * Removes an image from storage
 * @param key The s3 key
 * @param online Whether or not the user is online
 * @param direction The direction we need to delete from
 * @returns The result of the delete
 */
export default async function _removeImage(key: string, online: boolean, direction: "UP" | "DOWN"): Promise<void> {
	if (online) {
		try {
			if (direction === "UP") {
				const response = await deleteImageRoute(key);
				handleToolboxResponse(response);
			} else {
				await deleteImageBinary(key);
			}
		} catch (error) {
			recordSentry({ error, msg: "error removing file:" });
		}
	} else {
		deleteImageBinary(key);
	}
}
